function ReportListRow({
  fecha,
  legajo,
  evaluados,
  evaluacion,
  isSelected = false,
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`grid w-full grid-cols-[1fr_1fr_1.4fr_1fr] gap-3 border border-[#dce2e8] px-3 py-3 text-left transition ${
        isSelected ? 'bg-[#10a87f]' : 'bg-white hover:bg-[#f5faf7]'
      }`}
    >
      <span
        className={`font-login text-[10px] font-bold uppercase leading-[1.35] sm:text-[11px] ${
          isSelected ? 'text-white' : 'text-[#4b5563]'
        }`}
      >
        {fecha}
      </span>
      <span
        className={`font-login text-[10px] font-bold uppercase leading-[1.35] sm:text-[11px] ${
          isSelected ? 'text-white' : 'text-[#4b5563]'
        }`}
      >
        {legajo}
      </span>
      <span
        className={`font-login text-[10px] font-bold uppercase leading-[1.35] sm:text-[11px] ${
          isSelected ? 'text-white' : 'text-[#4b5563]'
        }`}
      >
        {evaluados}
      </span>
      <span
        className={`font-login text-[10px] font-bold uppercase leading-[1.35] sm:text-[11px] ${
          isSelected ? 'text-white' : 'text-[#4b5563]'
        }`}
      >
        {evaluacion}
      </span>
    </button>
  );
}

export default ReportListRow;
